export default {
  welcome                                                             : "WELCOME",
  home                                                                : "PAYMENT",
  application                                                         : "PAY YOUR INVOICES SECURELY",
  service                                                             : "WE ACCEPT",
  adyenInfo                                                           : "Adyen is an international payment company that offers merchants online services to accept electronic payments by payment methods such as credit cards, bank payments such as debit cards, bank transfers and wire transfers. real time based on online banking.",
  paypalInfo                                                          : "PayPal is an online payment service that allows you to pay for purchases, receive payments, or send and receive money. To take advantage of these services, a person must create an account and then send various bank details to PayPal, such as the credit card number.",
  transferInfo                                                        : "Bank transfer involves transferring money from one bank account to another. The account from which the money is withdrawn is debited and the account on which the money is paid is credited.",
  signIn                                                              : "Login / Sign up",
  continue                                                            : "Once connected, please click on",
  country                                                             : "Belgium, Morocco",
  onlinePayment                                                       : "Online payment",
  onlinePaymentInfo                                                   : "Our system supports payment by Discover, American Express, Maestro, Diners Club, Master Card and Visa.",
  yourorder                                                           : "YOUR ORDER",
  onlineCardTitle                                                     : "ONLINE PAYMENT",
  transferCardTitle                                                   : "Bank transfer",
  "About us"                                                          : "",
  owrApps                                                             : "Owr Apps",
  pageNotFound                                                        : "Oops, This Page Could Not Be Found!",
  creditNotes                                                         : "Credit notes",
  creditNotesList                                                     : "CREDIT NOTES LIST",
  logout                                                              : "",
  ordersHistory                                                       : "ORDERS HISTORY",
  paidOrders                                                          : "Paid Orders",
  unpaidOrders                                                        : "Unpaid Orders",
  app                                                                 : "App",
  organization                                                        : "Organization",
  street                                                              : "Street",
  locality                                                            : "Locality",
  postalCode                                                          : "Postal Code",
  purchaseOrder                                                       : "Purchase Order",
  invoice                                                             : "Invoice",
  docType                                                             : "Document type",
  help                                                                : "",
  Communities                                                         : "",
  webPage                                                             : "Web page",
  previous                                                            : "Previous",
  next                                                                : "Next",
  filter                                                              : "Filter",
  status                                                              : "Status",
  DRAFT                                                               : "",
  SENT                                                                : "",
  CREATED                                                             : "",
  language                                                            : "Language",
  issuerInvoices                                                      : "Your invoices",
  reset                                                               : "Reset",
  choseIban                                                           : "Choose an Iban first",
  addNewIban                                                          : "Add new Iban",
  searchBySubject                                                     : "Search by subject",
  journal                                                             : "Journal",
  supplement                                                          : "Supplement",
  refundAccount                                                       : "Refund Account",
  vatRate                                                             : "VAT Rate",
  refundStatus                                                        : "Refund Status",
  refund                                                              : "Refund",
  comment                                                             : "Comment",
  subject                                                             : "Subject",
  refundDate                                                          : "Refund date",
  cancel                                                              : "",
  save                                                                : "Save",
  codeOwn                                                             : "Code your own",
  createdAt                                                           : "Created At",
  cardNumber                                                          : "Card Number",
  cardHolderName                                                      : "Card Holder Name",
  cardExpirationDate                                                  : "Card Expiration Date",
  CV                                                                  : "CVC/CVV/CID",
  rememberDetails                                                     : "Remember these details",
  cardType                                                            : "Card Type",
  validate                                                            : "Validate",
  groups                                                              : "Groups",
  sent                                                                : "Sending",
  enterText                                                           : "Enter some text...",
  deleteCampaignConfirm                                               : "Are you sure you want to delete the campaign?",
  delete                                                              : "",
  fromEmail                                                           : "from email",
  fromName                                                            : "from name",
  replyTo                                                             : "REPLY TO",
  order_details                                                       : "Details of the order :",
  preVatAmount                                                        : "Amount before VAT",
  modifyOrder                                                         : "Modify my registration",
  vatAmount                                                           : "VAT Amount",
  includedVatAmount                                                   : "Included Vat Amount",
  lines_details                                                       : "Order lines details",
  moreErrordetails                                                    : "More details",
  description                                                         : "Description",
  price                                                               : "Price",
  quantity                                                            : "Quantity",
  loading                                                             : "Loading ...",
  confirmation                                                        : "Confirmation",
  validationMsg                                                       : "Do you want to continue? If yes click on validate",
  paymentAccepted                                                     : "Payment accepted",
  thanks                                                              : "Thanks",
  paymentRefused                                                      : "Payment refused",
  paymentPending                                                      : "Not possible to obtain the final status of the payment. You need to take further action to complete the payment.",
  paymentCancelled                                                    : "The payment was cancelled before completion.",
  paymentError                                                        : "An error occurred during the payment processing.",
  paymentRefusedApi                                                   : "The payment was refused. Payment authorisation was unsuccessful.",
  invoiceTo                                                           : "You will receive an email containing your invoice to this mail box",
  adyenErr                                                            : "Please try later",
  test                                                                : "",
  parameters                                                          : "",
  typeTestEmail                                                       : "Type the emails address you want to send the test to",
  warning                                                             : "warning",
  groupsIncluded                                                      : "GROUPS INCLUDED",
  excludedGroups                                                      : "EXCLUDED GROUPS",
  selectGroups                                                        : "Select Groups",
  "Select event"                                                      : "",
  "Select activities"                                                 : "",
  "Exclude activities"                                                : "",
  "Select status"                                                     : "",
  "Exclude status"                                                    : "",
  excludeGroups                                                       : "Exclude Groups",
  sendTitle                                                           : "You're about to send a campaign to",
  tested                                                              : "",
  attachments                                                         : "Attachments",
  confirm                                                             : "",
  confirmSendCampaign                                                 : "Are you sure you want to send this campaign?",
  noNotNow                                                            : "NO, NOT NOW",
  yesSend                                                             : "YES, SEND",
  sendTestTo                                                          : "Send test to",
  sendTest                                                            : "SEND TEST",
  send                                                                : "",
  PLAIN_TEXT                                                          : "PLAIN TEXT",
  WEB_PAGE                                                            : "WEB PAGE",
  selectTarget                                                        : "Select targeted audiences",
  campaignInfo                                                        : "Campaign info",
  invalidObject                                                       : "object must be at least 5 characters and no more than 200 characters",
  invalidFromName                                                     : "from name invalid, Please enter more than 4 character",
  invalidEmail                                                        : "invalid email address",
  emailAdd                                                            : "Add emails and type ENTER",
  userAdd                                                             : "Add user and type ENTER",
  deleteCampaignSuccess                                               : "Successful deletion",
  campaignDeleted                                                     : "The campaign was successfully deleted",
  campaignTestSent                                                    : "A test email has been successfully sent",
  campaignTestSuccess                                                 : "Successful test",
  campaignSent                                                        : "The campaign was sent successfully",
  campaignSentSuccess                                                 : "Successful sending",
  campaignAdded                                                       : "The campaign was saved successfully",
  addCampaignSuccess                                                  : "Successful adding",
  successfulAction                                                    : "Successful action",
  operationCompleted                                                  : "action performed successfully",
  errorOccured                                                        : "An error occured, Please retry later.",
  return                                                              : "Return",
  comingSoon                                                          : "COMING SOON",
  incompleteOperation                                                 : "Unable to complete operation, incorrect data was submited",
  invalidUrl                                                          : "Unable to complete operation, invalid url was submited",
  transferReminder                                                    : "To obtain confirmation of your registration, you must make your bank transfer with good structured communication (VCS). You can always decide to pay online, with immediate confirmation.",
  error                                                               : "",
  enterUrl                                                            : "Enter URL",
  search                                                              : "Search",
  deliveredTo                                                         : "Delivered to",
  emailsOpen                                                          : "Emails open",
  linkClicks                                                          : "Link clicks",
  Bounce                                                              : "",
  Spam                                                                : "",
  recipientsMessage                                                   : "this filter takes into consideration the language :",
  pauseCampaign                                                       : "pausing the campaign will prevent any furthers <br> emails from getting sent until it is reactivated",
  pauseSending                                                        : "pause sending any furthers emails",
  stopCampaign                                                        : "stop definitely campaign sending",
  resume                                                              : "",
  register_from_email                                                 : "This address is not valid for sending via Amazon, Click on VALIDATE to start the registration process.",
  reply_aws_email                                                     : "An email was sent to you by Amazon, Reply and Refresh",
  replyToError                                                        : "Please enter a valid email or text in the format : name <email@example.com>",
  GUEST                                                               : "",
  SPEAKER                                                             : "",
  CONTACT                                                             : "",
  PROSPECT                                                            : "",
  PARTNER                                                             : "",
  refresh                                                             : "",
  templateChoices                                                     : "Please select a template",
  stopCampaignConfirm                                                 : "Do you really want to stop this campaign definitely?",
  stop                                                                : "STOP",
  "first name"                                                        : "",
  "last name"                                                         : "",
  Event                                                               : "",
  "Included activities"                                               : "",
  "Excluded activities"                                               : "",
  "Included status"                                                   : "",
  "Excluded status"                                                   : "",
  Formulas                                                            : "",
  Slots                                                               : "",
  Options                                                             : "",
  All                                                                 : "ALL",
  templates                                                           : "",
  NEXT                                                                : "",
  nothing_found                                                       : "Oops, No results found for your search",
  yes                                                                 : "",
  no                                                                  : "",
  french                                                              : "French",
  english                                                             : "English",
  dutch                                                               : "Dutch",
  overview                                                            : "",
  links                                                               : "",
  recipients                                                          : "",
  approval_preferences                                                : "Approval preferences for an emailing campaign",
  "Send your campaign immediately"                                    : "",
  "Schedule sending of your campaign for a specific time"             : "",
  "send me"                                                           : "",
  "send to approvers"                                                 : "",
  "the approvers"                                                     : "",
  "the test is obligatory"                                            : "",
  "the minimum number of acceptance"                                  : "",
  "automatic sending"                                                 : "",
  "automatic_sending_paragraph"                                       : "allow the automatic sending of the campaign when reaching the limit number without any rejection",
  "test_obligatory_paragraph"                                         : "the campaign will not be sent until a test is sent",
  "minimum_acceptance_paragraph"                                      : "the minimum number of validation is required for automatic sending",
  "no_approver_found"                                                 : "you have not yet defined the approvers",
  "Add an approver"                                                   : "",
  "delivery date"                                                     : "date and time of sending",
  "Drag and drop some files here, or click to select files to upload.": "",
  "Attachments"                                                       : "",
  "about_us_content"                                                  : `Tamtam.pro is a suite of tools that enable a community to communicate, share, organise or collaborate efficiently. The platform is equipped with various applications assembled as required by the customer. Thanks to our mutuality tools, our customers have the latest technologies without having to develop them and invest in their core business.`,
  "preview"                                                           : "",
  "LEGAL_REPRESENTATIVE"                                              : "Legal Reprentative",
  'OFFICIAL': 'Official',
  'EXTERNAL': 'External',
  'MANAGER': 'Manager',
  "about_payment_method"                                              : `This section allows you to pay your bills. Please check one of the following methods and enter the information displayed.`,
  "choice_payment_mode"                                               : "choose a payment method",
  "bank_transfer"                                                     : "Transfer",
  "paymentUpdated"                                                    : "Payment updated",
  "payOnLine"                                                         : "Pay online",
  "payTransfer"                                                       : "Pay by transfer",
  "creditNoteRefunded"                                                : "Credit Note Refunded",
  "transferBank-about"                                                : "Once your order has been placed, you can pay by bank transfer.",
  "transferBank-about-2"                                              : "You will find the necessary information above: IBAN, BIC and VCS (for structured communication).",
  "transferBank-about-3"                                              : "Note that a wire transfer requires at least 48 hours for the money to be transferred from one account to another. Upon receipt of your payment, your order will be validated and an invoice will be sent to you to the Email address:",
  "hello"                                                             : "Hello",
  "badge1"                                                            : "choose a payment method from the three modes.",
  "badge2"                                                            : "depending on the method of payment chosen you will have a form to fill out.",
  "badge3"                                                            : "you can change your pack.",
  "adyen1"                                                            : "Thanks to Adyen, you have an international reach using a single system.",
  "adyen2"                                                            : " Adyen is a flexible, global and fully compliant payment solution for marketplaces.",
  "virement1"                                                         : "This is a payment method that is not online.",
  "virement2"                                                         : "In this case please go to the nearest bank to pay us the amount according to your order on the account whose RIB is indicated below",
  "onlinePaymentDesc"                                                 : "With our solution you can pay by Discover Card, American Express, Maestro, Diners Club, Master Card or Visa.",
  "badgeAdmin1"                                                       : "You have to download the coda file sent by the bank.",
  "badgeAdmin2"                                                       : "choose a coda file that you have already imported into the room.",
  "badgeAdmin3"                                                       : "click the Create Payments button to create the payments associated with this coda file and to match payment with orders.",
  "titreUser"                                                         : "List of users",
  "listeTransfers"                                                    : "List of transfers",
  "listeOrders"                                                       : "Liste of orders",
  "dropzoneText"                                                      : "Drag and drop one or more coda files",
  "titreResult"                                                       : "Liste of imported transfers",
  "authorizePayment"                                                  : "Payment methods",
  "number"                                                            : "Number",
  "prevatAmount"                                                      : "PreVat Amount",
  "coponCode"                                                         : "Coupon code",
  "refClient"                                                         : "Client Reference",
  "amount"                                                            : "Amount",
  "bankRef"                                                           : "Bank Reference",
  "operationCode"                                                     : "Operation Code",
  "extrait"                                                           : "Extract",
  "numOperation"                                                      : "Operation Number",
  "phone"                                                             : "Phone",
  "createPayment"                                                     : "Create Payment",
  "reconsillation-coda"                                               : "Coda Reconciliation",
  "orders"                                                            : "ORDERS",
  "customers"                                                         : "CUSTOMERS",
  "transfers"                                                         : "BANK TRANSFERS",
  "mapCoda"                                                           : "RECONCILIATION",
  "codaImport"                                                        : "CODA IMPORT",
  "choice"                                                            : "Choice",
  "associate"                                                         : "Associate",
  "associated-status"                                                 : "Status association",
  "acheteur"                                                          : "Buyer",
  "warning-association-button"                                        : "check both sides",
  "warning-importation-button"                                        : "you have to choose at least one Coda file",
  "payment-app"                                                       : "Application",
  "admin-espace"                                                      : "ADMINISTRATOR SPACE",
  "settings"                                                          : "Settings",
  "transfer"                                                          : "Transfer",
  "credit_note_refunded"                                              : "This credit note is already refunded in this account : ",
  "credit_note_refunded1"                                             : "Please consult another credit note",
  "iban_credit_note"                                                  : "Enter your Iban so that we can refund you on your account",
  "saveIban"                                                          : "Your Iban is successfully registered",
  "not_user"                                                          : "you are not the user of this credit note",
  "iban_invalid"                                                      : "Iban is not valid",
  "bic_invalid"                                                       : "Bic is not valid",
  "import_coda_1"                                                     : "Codas that had already been imported",
  "warning_search_mapping"                                            : "You must check a transfer",
  "warning_search_bankTransfer"                                       : "You must check an order",
  "ignor"                                                             : "Ignore",
  "force-association"                                                 : "Forcing the association",
  "NOT_REFUNDED"                                                      : "Not Refunded",
  "REFUNDED"                                                          : "Refunded",
  "BANK_TRANSFER"                                                     : "bank transfer",
  "OGONE"                                                             : "Ogone",
  "PAYPAL"                                                            : "Paypal",
  "MANGO_PAY"                                                         : 'Mango Pay',
  "MANUAL"                                                            : "Manual",
  "NOT_MAPPED"                                                        : "Ignored",
  "ATTRIBUTED"                                                        : "Associated",
  "ASSOCIATED"                                                        : "Associated",
  "NOT_ASSOCIATED"                                                    : "Not associated",
  "sucess-file"                                                       : "Codas files processed successfully",
  "operation"                                                         : "Operation",
  "related-operations"                                                : "Related operations",
  "attribute"                                                         : "Attribute",
  "manual-payment"                                                    : "Payment difference (payment manual)",
  "credit-note-number"                                                : "Number ",
  "credit-note-organization"                                          : "Organization :",
  "credit-note-date"                                                  : "Create at :",
  "credit-note-apply"                                                 : "Apply",
  "show-invoice"                                                      : "download the invoice in PDF",
  "invalid-coda-files"                                                : "Invalid Coda files",
  "no-data-filter-left"                                               : "No data found for",
  "no-data-filter-right"                                              : "using this filter.",
  "delete-filter"                                                     : "Delete this filter.",
  "PAID"                                                              : "Paid",
  "OVER_PAID"                                                         : "Over Paid",
  "UNDER_PAID"                                                        : "Under Paid",
  "NOT_PAID"                                                          : "Not Paid",
  "ORDER"                                                             : " Order",
  "INVOICE"                                                           : "Invoice",
  "CREDIT_NOTE"                                                       : "Credit Note",
  "Date"                                                              :"Date",
  "user-email"                                                        :"User Email",
  "To"                                                                :"To",
  "Application"                                                       : "Application",
  "document-number"                                                   :"Number of selected documents is: ",
  "document-total"                                                    : "Total amount of documents is : ",
  "document-total-selected"                                           : "Total amount of selected documents is : ",
  "Import Coda files"                                                 :"IMPORT CODA FILES",
  "Pending"                                                           : 'Pending',
  "Documents"                                                         : "Documents",
  "Assignments"                                                       : "Assignments",
  "PAYMENT_DIFFERENCE"                                                : "Payment difference",
  "EXCHANGE_DIFFERENCE"                                               : "Exchange difference",
  "CACHE_PAYMENT"                                                     : "cash payment",
  "TOO_MUCH_PAID"                                                     : "Over payed",
  "PAYMENT_OTHER_ACCOUNT"                                             : "Payment other account",
  "required-value"                                                    : "This field is required",
  "show-order"                                                        : "download the order in PDF",
  "order-detail"                                                      : "Detail of the order",
  "show"                                                              : "Display",
  "uen"                                                               : "VAT number",
  "get-pdf"                                                           :"Download the pdf",
  "get-efff"                                                           :"Download the EFFF",
  "send-by-mail"                                                      :"Send by mail",
  "redo-pdf"                                                          :"Regenerate the pdf",
  "client-data"                                                       :"Customer data",
  "not-order-user"                                                    : "You are not the user of this Order",
  "Sous-Type"                                                         :"Sub Type",
  'Vous avez importé XXXX fichiers coda'                              : 'You have imported XXXX coda files',
  'paiements non réconciliés'                                         : 'unreconciled payments',
  'paiements réconciliés'                                             : 'reconciled payments',
  'paiements ignorés'                                                 : 'ignored payments',
  'pour'                                                              : 'for',
  "show-stats"                                                        :"Show statistics",
  "stats"                                                             : "statistics",
  "EN QUELQUES CHIFFRES"                                              : "IN A FEW NUMBERS",
  "Facturation"                                                       : "Billing",
  "CA"                                                                : "Turnover",
  "payment-ogone"                                                     : "Consult the dates and invoices paid by Ogone",
  "payment-virement"                                                  : "Consult the dates and invoices paid by bank transfer",
  "invoices-not-paid"                                                 : "Unpaid invoices",
  "facture-a-payer"                                                   : "Invoices to pay",
  'Nothing to show'                                                   : '',
  "Notifications of updates"                                          : "",
  "Invoices"                                                          : "Invoices",
  "manual-amount"                                                     : "Manual Amount",
  "manual-comment"                                                    : "Manual Comment",
  "user-phone"                                                        :"Telephone number",
  "VALID"                                                             : "Active",
  "CANCELED"                                                          : "Canceled",
  "to-be-refunded"                                                    : "To repay",
  "MONTH"                                                             : "Month",
  "CHOOSE-EVENEMENT"                                                  : "Choose an event",
  "search by name"                                                    : "Search by name",
  "ORDERS"                                                                  : "Orders",
  "INVOICES"                                                                  : "Invoices",
  "CREDIT-NOTES"                                                                  : "Credit notes",
  "ACCOUNTANT" : "ACCOUNTANT",
  "ASSISTANT" : "ASSISTANT",
  "AUCUN" : "NONE",
  'success-save-iban-bic' : "Data is successfully saved",
  'assistant-title' : "« These data can only be modified by the Admin »",
  'configure-data' : "Organization data configuration",
  'import-coda-test': "Generate test coda file",
  'Import Coda Testing' : "Generate coda test",
  'and': "and",
  'other user(s)' : 'other user(s)',
  'all_event' : "All events",
  'other_year' : "other year(s)",
  'other_event' : "other event(s)",
  'unabledCommunity': "You do not have the access to continue with this community!",
  "none-event" : "No events",
  "payer-mongo-pay" : "Pay with Mongo Pay",
  "Payer-sans-enregistrer-la-carte" : "Pay with another card",
  "Payer-avec-cette-carte" : "Pay with this card",
  "Enregistrer-et-payer-avec-une-autre-carte" : "Register my card",
  "ou" : "OR",
  "card-Number" : "Card number",
  "expiration-Date" : "Expiration date",
  "cardNumber_invalid" : "Card number is invalid",
  "date dexpiration_invalid" : "Expiration date is invalid",
  "cvv_invalid" : "CVV is invalid",
  "visualiser-document" : "View the document",
  "visualiser-vos-document" : "View your documents",
  "visualiser-vos-paiement" : "View payments",
  "reconcilier-paiement" : "Reconcile payment",
  "payment-ok" : "Payment is successful",
  "Montant-payer" : "Amount to be paid : ",
  "credit-card" : "Credit card",
  "debit-card" : "Debit card",
  "pay": "Pay",
  "choice-methode-paiement" : "Choose your payment method",
  "Payer-ici" : "Pay here :",
  "cgu" : "Terms of Service",
  "order-post-traitment" : "This order is the subject of a failed reconciliation process.",
  "data-organization" : "Organization data",
  "gestion-rappel" : "Management of reminders",
  "interval": "Determine the time interval for reminders for each application.",
  "modify-emailing-all-application" : "Modify templates for all applications",
  "modify-emailing--application" : "Modify templates",
  "events" : "Events / cycles / pack",
  "default-config" : "Default configuration",
  "send-last-rappel" : "Send the last reminder",
  "send-rappel" : "send reminder",
  "re-send-rappel" : "re-send reminder",
  "show-ebox-admin" : "See their E-box",
  "progress-bar-documents" : "paid documents : ",
  "progress-bar-documents-credit-notes" : "Refunded credit notes : ",
  "progress-bar-rappels" : "Reminders sent : ",
  "sended": "Sent",
  "sende": "Has sent",
  "innaproprie": "Inappropriate",
  "edit-campagne" : "Edit campaign",
  "send-campagne" : "Send campaign",
  "send-campagne-relance" : "Send a campaign of reminders",
  "years" : "Years",
  "add-year" : "Add a year",
  "apps" : "The applications",
  "add-app" : "Add an application",
  "add-event" : "Add an event / cycle / pack",
  'registering' : "training",
  'cycle_registering' : "Cycle",
  'packOrder' : "pack",
  "inscription-type" : "Type of registration",
  "add-inscription" : " add Type of registration",
  "send-second-rappel" : "Send the next reminder",
  "qr-expiration" : "The pay coniq QR code will be expired in :",
  "payment-mango-pay": "Consult the dates and invoices paid by Mango Pay",
  "payment-pay-coniq": "Consult the dates and invoices paid by Pay Coniq",
  "BANK_TRANSFER_MANGO_PAY" : "MangoPay transfer",
  "BANK_TRANSFER_PAYCONIQ" : "Payconiq transfer",
  "PAY_CONIQ"                                                               : 'Payconiq',
  "DOWNLOAD_ORDER" : "Download the order",
  "NEW_BANK_CARD": "New bank card",
  "YES_DELETE": "Yes, delete",
  "CONFIRM_DELETE_CARD": "Are you sure you want to delete this bank card?",
  "BANK_DETAILS": "Bank details",
  "MANGOPAY_CONFIGURATION": "Mangopay Configuration :",
  "PAYCONIQ_CONFIGURATION": "Payconiq configuration :",
  "TRANSFERS_CONFIGURATION": "Configuration of transfers :",
  "SEND_DOCUMENT_ONLINE": "Send the document via email",
  "ARTICLE_CODE": "Item code",
  "REFUND_DATE_MANDATORY": "The refund date is mandatory",
  "REFUND_TYPE_MANDATORY": "The refund type is mandatory",
  "REFUND_JUSTIFICATION_MANDATORY": "The refund justification is mandatory",
  "REGISTRATION_CANCELED": "Registration canceled",
  "REFUND_TYPE_PLACEHOLDER": "Refund type",
  "REFUND_JUSTIFICATION_PLACEHOLDER": "Refund justification",
  "clientName"                                                               : "Name of client",
  "Prix/Base" : "Price/Base",
  "choice-client" : "Choose a Client",
  "commission-sum" : "Sum of commissions : ",
  "ACTION_CONFIGURATION": "Action configuration",
  "ACTION_CONFIGURATION_SAVED": "The configuration has been saved",
  "ACTIONS": "Actions",
  "ACTION": "Action",
  "EMAIL_TYPE": "Email type",
  "HOURS_NUMBER": "Number of hours",
  "ACTION_CONFIGURATION_ERROR": "Please select values for all fields",
  "WAITING_INTERVAL": "Waiting interval",
  "ACTION_DATE": "Action Date",
  "EVENT_CYCLE": "Event/Cycle",
  "RAPPEL": "Reminder",
  "TITLE": "Title",
  "PAID_REGISTRANTS": "Paid registrants",
  "FREE_REGISTRANTS": "Free registrants",
  "TOTAL": "Total",
  "DETAILS": "Details",
  "PAYOUT_RATE": "Payout rate",
  "Order": "Orders",
  "AVERAGE_PRICE": "Average price per purchase",
  "REGISTRATION": "registration",
  "TYPE": "Type",
  "FORMAT": "Format",
  "REGISTRATIONS": "registrations",
  "from_time": "from",
  "to_time": "to",
  "DISPLAY_TRAININGS": "Display the trainings of the cycle",
  "CYCLE_TRAINING": "Cycle training :",
  "REDUCE_CYCLE": "Reduce cycle training",
  "GLOBAL": "Global",
  "ACTIVITIES": "Activities",
  "REGISTERED": "Registered",
  "PAYING": "Paying",
  "FREE": "Free",
  "PAGE_NOT_FOUND": "Page not found",
  "PAYMENT_REFUSED_MESSAGE": "We regret that we are unable to respond favorably to your request for payment.",
  "RETRY_PAYMENT": "retry payment",
  "GENERAL": "General",
  "REFUND_PAGE_HEADER": "Modify my refund details",
  "BANK": "Bank",
  "ATTRIBUTE_WITH_VCS": "Assign via VCS",
  "ATTRIBUTE_WITH_VCS_MESSAGE": "Do you want to assign this transfer via VCS?",
  "REFUND_DONE": "The refund has already been made.",
  "DATE_CREATION": "Creation date",
  "COMPLETE_FIELDS": "Please complete all fields",
  "COMMAND_LINES": "Command lines",
  "VIEW_REFUND_DETAILS": "View refund details",
  "CA_FROM_CYCLES": "Revenues generated from cycles",
  "MODEL_RELANCE": "Stimulus models",
  "MANAGEMENT_REMINDERS": "Management of reminders",
  "REMINDER_SUBTITLE": "Determine the restart time interval for each application.",
  "ORGANIZATION_DATA": "Organization data",
  "VIREMENT": "Transfers",
  "EMAIL_CONFIGURATION": "Configure emails",
  "MODEL_RAPPEL": "Reminder Templates",
  "SELECT_ALL": "Select all",
  "DESELECT_ALL": "Deselect all",
  "PERSONS": "Persons",
  "first-payment" : "First Payment",
  "date-first-payment" : "Date of 1st Payment",
  "second-payment" : "Second Paiement",
  "date-second-payment" : "Date of 2nd Payment",
  "payment-account" : "Payment account",
  "double-payment" : "Double paid orders",
  "MANGO_REFUND_CONFIRM_TITLE" : "Do you really want to make a refund with Mango pay?",
  "REFUND_WITH_MANGO_PAY" : "Refund with Mango Pay",
  "ADMINISTRATION": "Administration",
  "FEES_CONFIGURATION": "Fees configuration",
  "CREDIT_CARD_CONFIGURATION": "Setting up credit cards",
  "DEBIT_CARD_CONFIGURATION": "Setting up debit cards",
  "FEES_SECTION_SUBTITLE": "Determine fixed and variable commissions for each organization",
  "FIX_FEE": "Fixed fee",
  "VARIABLE_FEE": "variable commission",
  "MANGO_FEES": "Mango Pay Fees",
  "event-list" : "List of upcoming events",
  "SELECT_REFUNDED_ORDERS" : "Please select the orders that you have refunded by bank transfer:",
  "CONFIRMATION_MESSAGE" : "Voulez-vous vraiment faire cette action ?",
  "REFUNDED_WITH_BANK_TRANSFER" : "Refunded by bank transfer",
  "FEES_PER_TRANSACTION" : "Commission per transaction",
  "AMOUNT_PER_TRANSACTION" : "Transaction amount",
  "refund-payment" : "Refund",
  "creditor" : "operator",
  "payment" : "Payment",
  "detail-payment-refund" : "Details of payments and refunds",
  "ORDER_LINES": "Order lines",
  "INVOICE_LINES": "Invoice lines",
  "CREDIT_NOTE_LINES": "Credit Note lines",
  "ACTIVATED" : "Activated",
  "DEACTIVATED" : "Deactivated",
  'CREDIT_NOTE_PARTIAL' : 'Partial credit note',
  'CREDIT_NOTE_CONFIRM_TITLE' : 'Are you sure you want to create a credit note for this invoice?',
  'CREDIT_NOTE_CREATED_MESSAGE' : 'A credit note has already been created for this invoice',
  'PARTIAL_CREDIT_NOTE_CREATED_MESSAGE' : 'A partial credit note has already been created for this invoice with an amount of ',
  'PARTIAL_CREDIT_NOTE_CREATED_PLURAL_MESSAGE' : 'Partial credit notes have already been created for this invoice with an amount of ',
  'FEED_MANGO_WALLET' : 'Feed your wallet',
  'ENTER_AMOUNT_FOR_MANGO_WALLET' : 'Please enter the amount with which you want to fund your wallet : ',
  'MANGO_WALLET_BALANCE' : 'Your wallet balance is : ',
  'USE_THIS_CARD' : 'Use this card',
  'FEED_MANGO_WALLET_QUESTION' : 'Do you want to feed your wallet?',
  'REFUND_SUCCEEDED' : 'The refund was successfully made',
  'REFUND_FAILED' : 'Refund failed due to lack of balance.',
  'CREATE_PARTIAL_CREDIT_NOTE_SUM_ERROR' : 'The sum of the credit note amounts exceeds the total amount of the invoice',
  'PAYOUT_SUM_ERROR' : 'The amount is greater than what you have on your wallet',
  'ENTER_PAYOUT_AMOUNT_FOR_MANGO' : 'Please enter the amount you want to transfer to your bank account ',
  'payout' : 'Make a payout',
  'CREATE_CREDIT_NOTE' : 'Create a credit note',
  'PRODUCT_GROUP' : 'Product group',
  'ADD_LINE' : 'Add a line',
  'EXCLUDING_VAT_TOTAL' : 'Total excl. VAT',
  'INCLUDING_VAT_TOTAL' : 'Total incl. VAT',
  'CREDIT_NOTE_AMOUNT_ERROR' : 'The total amount of the credit note may not exceed the amount of the invoice.',
  'CANCEL_REGISTRATION_1' : 'Cancel the registration of ',
  'CANCEL_REGISTRATION_2' : ' linked to this invoice',
  'not_refund_credit_note' : 'Not refunded credit notes',
  'dashboard' : 'Dashboard tools',
  'import-coda-via-email' : 'Import Coda via email',
  'user-name-invalid' : 'Invalid email address',
  'password-invalid' : 'Password is required',
  'password' : 'Password',
  'mail-box-invalid' : 'imap server is required',
  'test-connection' : 'Test connection',
  'configure-imap' : 'Configuring the IMAP connection',
  'connection-success' : "The connection is established",
  'config-imap' : "Configuring Imap",
  'server-imap' : "Server imap",
  'from-email' : "Import only codas that come from:",
  'user-name' : "Source email",
  'port-invalid' : 'Port is required',
  'REGISTRATIONS_TOTAL_NUMBER' : "Total number of registrations",
  "TRAININGS" : "trainings",
  "CYCLES" : "cycles",
  "SEASONS" : "seasons",
  "CONGRESS" : "congress",
  "CYCLES_ESSENTIAL" : "essential cycles",
  "DAILY" : "Daily",
  "WEEKLY" : "Weekly",
  "MONTHLY" : "Monthly",
  "YEARLY" : "Yearly",
  "RETRY" : "Retry",
  "ERROR_OCCURED" : "An error has occurred. Please try again!",
  "Jan" : "Jan",
  "Fév" : "Feb",
  "Mar" : "Mar",
  "Avr" : "Apr",
  "Mai" : "Mai",
  "Jui" : "Jun",
  "Jul" : "Jul",
  "Aoû" : "Aug",
  "Sep" : "Sep",
  "Oct" : "Oct",
  "Nov" : "Nov",
  "Déc" : "Dec",
  "NO_REGISTRATIONS" : "There are no registrations in the selected period.",
  'HTVA' : 'excl. VAT',
  'TVAC' : 'incl. VAT',
  'TVA' : 'VAT',
  'FACTURATIONS' : 'Facturations',
  'INDIVIDUAL_FORMULAS' : 'Individual formulas',
  'COMPANY_PACKS' : 'Company Packs',
  "GUESTS": "Guests",
  "PAID_FREE_PACK_REGISTRANTS": "Paid registrants + Free registrants + Pack registrants",
  "LAST_CACHE_UPDATE": "Last update of the data: ",
  "NOW": "now",
  "DOWNLOAD_DOCUMENTS_IN_XML_FORMAT": "Download documents in xml format",
  "SUBSCRIPTIONS_PAGE_TITLE": "Subscriptions",
  "SUBSCRIPTIONS_PAGE_SUBTITLE": "Manage your subscriptions",
  "SUBSCRIPTION_CANCELLED": "Interrupted",
  "SUBSCRIPTION_STOPPED": "Stopped",
  "SUBSCRIPTION_FAILED": "Failed",
  "FREQUENCY": "Frequency",
  "SUBSCRIPTION_LAST_PAYMENT": "Last payment",
  "NO_SUBSCRIPTION_FOUND": "You have no subscription",
  "SUBSCRIPTION_NEXT_DEBIT_INFO": "The next direct debit is for ",
  "SUBSCRIPTION_FAILED_DEBIT_INFO": "Direct debit failure, please view the subscription history to resolve the problem",
  "SUBSCRIPTION_ENDED_INFO": "Your subscription has been cancelled. (direct debit failure)",
  "SUBSCRIPTION_CANCELLED_INFO": "Your subscription is suspended. That will actually end on ",
  "SUBSCRIPTION": "Subscripiton",
  "CHANGE_MY_CARD": "Change my card",
  "CANCEL_SUBSCRIPTION": "Cancel my subscription",
  "BILLING_DATA": "Billing data",
  "CANCEL_SUBSCRIPTION_TITLE": "Change the card linked to the subscription",
  "CANCEL_SUBSCRIPTION_CONFIRMATION": "Wil je echt je abonnement opzeggen?",
  "CARD_USED_FOR_SUBSCRIPTION": "The card used for this subscription is ",
  "SUBSCRIPTION_CHANGE_CARD_INFO_1": "To check the new card, you will be charged ",
  "SUBSCRIPTION_CHANGE_CARD_INFO_2": "A refund will be made afterwards.",
  "NEW_CARD": "New bank card",
  "DOWNLOAD_INVOICE": "Download the invoice",
  "DOWNLOAD_CREDIT_NOTE": "Download the credit note",
  "SUBSCRIPTION_CANCELLED_LOG": "You have cancelled your subscription",
  "CIT_SUCCEEDED": "Initialization payment made successfully",
  "MIT_SUCCEEDED": "Successful bank debit",
  "MIT_FAILED": "Failed bank withdrawal",
  "MIT_FAILED_AUTHENTICATION_NEEDED": "Direct debit failed: 3DS authentication request by the bank",
  "MIT_FAILED_INACTIVE_CARD": "Bank debit failed: Card inactive",
  "MID_CIT_SUCCEEDED": "Payment done successfully",
  "MID_CIT_FAILED": "Payment failed",
  "CARD_CHANGED": "The card linked to your subscription has been changed",
  "PAYMENT_FAILED": "Failed payment of ",
  "CARD_ACTIVATED": "Active card: payment of ",
  "MID_CIT_REFUND_SUCCEEDED": "The refund of the activation amount of the card is done successfully",
  "MID_CIT_REFUND_FAILED": "Refund of the card activation amount failed",
  "SUCCESS": "Success",
  "SUBSCRIPTION_HISTORY": "Subscription history :",
  "CARD_IN_USE": "In use",
  "SUBSCRIPTIONS_SUPPORTED_CARDS_INFO": "Recurring card payments are only available with CB/Visa/Mastercard. The following cards are not supported: Amex, Maestro, and BCMC.",
  "YES_CANCEL": "Yes, cancel",
  "FREE_TRIAL_STARTED": "Start of your free trial period",
  "FREE_TRIAL": "Free trial",
  "FREE_TRIAL_MONTH": " during your first 30 days.",
  "WE_SEND": "We will send you ",
  "BILLING_EMAIL": "a billing e-mail for each collection made.",
  "NEXT_DEBIT": "Next monthly withdrawal is for ",
  "WITHOUT_COMMITMENT": "Without commitment.",
  "SUBSCRIPTION_CAN_BE_CANCELLED": " Subscription can be cancelled online at any time.",
  "DEFINE_CARD": "Define your payment card:",
  "ftp_config" : "FTP configuration",
  "DOWNLOAD_DOCUMENTS_FTP" : "Export documents to FTP server",
  "user_name" : "User Name",
  "host_name" : "Host Name",
  "protocol" : "Protocol",
  "new_client" : "New Client",
  "client_state" : "Client State",
  "last_invoice" : "Last invoice",
  "OFFER_WITHOUT_INVOICE": "Offer (without invoice)",
  "FORCE_WITH_INVOICE": "Force (with invoice)",
  "REGISTRATION_WAS_OFFERED": "Registration was forced. (offered)",
  "REGISTRATION_WAS_FORCED": "Registration was forced. (pending payment)",
  "FORCE_REGISTRATION": "Force registration",
  "TEL": "Tel.",
  "reminder_sent" : "Don't send Reminders",
  "PREVIOUS_INVOICE" : "Previous invoice",
  "FILES_SUCCESSFULLY_IMPORTED": "The files have been successfully imported",
  "CONFIGURE_MODELS": "Configure the models",
  "IMPORT": "Import",
  "IMPORT_CODAS_VIA_DROPBOX": "Import codas via Dropbox",
  "CONFIGURE_DROPBOX": "Configure Dropbox",
  "CONNECT_TO_DROPBOX": "Connect to Dropbox",
  "FOLDER_NOT_FOUND": "Folder not found",
  "DROPBOX_FOLDER": "Dropbox Folder",
  "invalid-uen": "The VAT number is invalid",
  "IMPORT_NOW": "Import now",
  "CODA_IMPORT_COMMAND_STARTED": "The import command of the codas files has been launched. The organization's contact will receive an email as soon as the import is completed.",
  "CONFIGURED_FOLDER": "The configured folder is : ",
  "DROPBOX_FOLDER_NOT_CONFIGURED": "The Dropbox folder has not been configured.",
  "SUBSCRIPTION_UPGRADED": "You have changed your subscription formula",
  "CHOOSE_WALLET_FEEDING_MODE": "Choose your wallet feeding mode",
  "SEE_BANK_TRANSFERS": "View bank transfers",
  "BANK_CARD": "Bank card",
  "ENTER_TAG": "Please enter a tag to identify the bank transfer",
  "PAYMENT_CREATED": "The payment has been created but has not yet been approved and processed.",
  "PLEASE_MAKE_TRANSFER": "Please make a transfer of {amount} and check back later.",
  "WIRE_REFERENCE": "Wire transfer reference",
  "ADDRESS": "Address",
  "CITY": "City",
  "COUNTRY": "Country",
  "CREATED_BANKWIRES": "Created bank transfers",
  "VIEW_SUBSCRIPTION": "View subscription",
  "dropbox_count_down" : "The next automatic import will be in :",
  "missing_coda_info" : "Warning, there are missing Codas files, for more details please consult this ",
  "link" : "link",
  "previous_date" : "Date of the previous Coda file",
  "next_date" : "Date of the next Coda file",
  "account" : "Organization account",
  "missing_coda_list" : "List of missing coda files",
  "balance" : "The balance of the date  : ",
  "is" : " is : ",
  "autorize_balance" : "Allow balance to display",
  "balance_privilege" : "Balance privileges",
  "total_balance" : "The total balance ",
  "LAST_REMINDER": "Last reminder",
  "DOCUMENTS": "The documents",
  "CAMPAIGNS": "The campaigns",
  "NUMBER" : "Number",
  "JANUARY": "January",
  "FEBRUARY": "February",
  "MARCH": "March",
  "APRIL": "April",
  "MAY": "May",
  "JUNE": "June",
  "JULY": "July",
  "AUGUST": "August",
  "SEPTEMBER": "September",
  "OCTOBER": "October",
  "NOVEMBER": "November",
  "DECEMBER": "December",
  "START_MONTH": "Start Month:",
  "END_MONTH": "End Month:",
  "COMPARE_WITH_ANOTHER_YEAR": "Compare with another year",
  "REDUCE": "Reduce",
  "CA_TOTAL_NUMBER" : "Total amount of turnover excl. VAT",
  "REGISTRATIONS_COMPARE_STATS": "Comparison of the total number of registrations",
  "CA_COMPARE_STATS": "Comparison of the total sum of the turnover excl. VAT",
  "MANAGE_MY_TURNOVER" : "Manage my turnover",
  "ALL" : "ALL",
  "REGISTRANTS_TOTAL_NUMBER" : "Total number of paying registrants",
  "PRICE_PER_UNIT" : "Price per unit",
  "TOTAL_BUDGET" : "Total budget",
  "ANNUAL_TARGET" : "Annual target",
  "ANNUAL_TARGET_TEXT" : "Set measurable and achievable targets to ensure you are on track.",
  "COMPARE_TO_PREVIOUS_YEAR" : "than the previous year",
  "COMPARE_PLUS" : "moreover",
  "COMPARE_MINUS" : "less",
  "CURRENT_BUDGET_RESULT" : "Current budget result ",
  "TOTAL_REALIZED" : "Total realized",
  "ANNUAL_ADJUSTMENT_RESULT" : "Annual adjustment result",
  "TOTAL_ADJUSTMENT" : "Total adjustment",
  "FROM" : "from",
  "TO" : "au",
  "COMPARISON_CA_TB" : "Comparison of the achieved turnover with the target budget",
  "COMPARISON_ADJUSTMENT_TB" : "Comparison of annual adjustment with the target budget",
  "FOLLOW_UP" : "Follow-Up",
  "NO_ANALYSIS" : "No analysis was generated",
  "FOLLOW_UP_TXT1" : "Take the time to carefully configure your {year} goal budget before generating any follow-up.",
  "FOLLOW_UP_TXT2" : "Please note! The {year} budget cannot be modified after the generation of the follow-up.",
  "GENERATE_FOLLOW_UP" : "GENERATE THE FOLLOW-UP",
  "TARGET_BUDGET" : "Target Budget",
  "REALIZED_BUDGET" : "Realized Budget",
  "INCOME" : "Income",
  "REALIZED" : "Realized",
  "ADJUSTMENT" : "Adjustment",
  "NO_CONFIG_DONE" : "No configuration has been done",
  "CHANGE_FILTER_WITHOUT_SAVING" : " You risk losing your unsaved configuration, do you want to continue?",
  "reminders" : "Reminders",
  "revivals" : "Revivals",
  "QUIT" : "Quit",
  "DOWNLOAD_SEPA" : "Download the SEPA file",
  "import_manuel" : "Import Manually",
  "import_automatic" : "Import Automatically",
  "DELETE_CONFIGURATION" : "Delete configuration",
  "DELETE_CONFIGURATION_QUESTION" : "Do you really want to remove this configuration?",
  "RESUME_SUBSCRIPTION" : "resume my subscription",
  "CANCEL_DOCUMENT" : "cancel the order",
  "ORDER_CANCELLATION_MESSAGE" : "The order has been canceled",
  "ORDER_CANCELLATION_CONFIRM" : "Do you want to cancel this order ?",
  "IS_CANCELED" : "Canceled",
  "EDIT" : "edit",
  "UPDATE_CONFIGURATION_QUESTION" : "Do you really want to edit this configuration?",
  "address_line2": "Adress 2",
  "order_number": "Your references",
  "another_infos": "See more information",
  "SUBSCRIBER": "subscriber",
  "SUBSCRIBERS": "subscribers",
  "RECURRENCE_COEFF" : "The recurrence coefficient",
  "CODA_FILES" : "Coda files",
  "VIEW_CODA_FILES" : "View coda files",
  "CODA_FILES_RECONCILED" : "Coda files reconciled",
  "EDIT_CODA_FILES" : "Enrich reconciled codas",
  "EDIT_CODA_FILE" : "Enrich Coda File",
  "CODA_FILE_NAME" : "Coda file name",
  "RECONCILED_PAYMENTS" : "All payments are reconciled",
  "RECONCILE_PAYMENTS" : "Reconcile payments",
  "START_BALANCE" : "Initial balance",
  "END_BALANCE" : "final balance",
  "ACCOUNT" : "All accounts",
  "ENRICHED_CODA_FILES" : "Enriched codas",
  "NOT_ENRICHED_CODA_FILES" : "Not enriched codas",
  "MANGOPAY_ACCOUNT" : "Mangopay account",
  "IS_CODA_FILE_MODIFIED" : "Fichier coda enrichi",
  "EDIT_ALL_CODA_FILES" : "Enrich all Coda files",
  "DOWNLOAD_CODA_FILE_IN_ZIP_FORMAT": "Download coda files in zip format",
  "NO_RECURRENCE_COEFF_FOR_THIS_YEAR" : "No recurrence coefficient this year since it is the first year.",
  "NEW_REGISTRANTS_TOTAL_NUMBER" : "Total number of new paying registrants",
  "NEW_REGISTRANTS" : "New registrants",
  "FORMER_REGISTRANTS" : "Former registrants",
  "TOTAL_REGISTRED" : "Total registered",
  "MONTHLY_PREMIUM" : "Monthly premiums",
  "YEARLY_PREMIUM" : "Yearly premiums",
  "NUMBER_OF_SAMPLES" : "Number of samples",
  "MONTHLY_PREMIUM" : "Monthly premiums",
  "YEARLY_PREMIUM" : "Yearly premiums",
  "DOCUMENT_DOWNLOADED" : "The document has been uploaded",
  "COMPARE": "Compare",
  "Cotisation" : "Contribution",
  "CA": "Turnover",
  "Type cotisations" : "Type of contributions",
  "Statutaire" : "Statutory",
  "Fiduciaire" : "Trustee",
};



// WEBPACK FOOTER //
// ./app/i18n/en.js